// @flow
import environment from '../environment';
import {getCookie} from '../utils/cookies';
import {loadScript} from './utils';

type Command = 'init' | 'page' | 'track' | 'identify';

type AnalyticsWindow = (command: Command, ...args: any) => void;

type Provider =
  | 'google-tag-manager'
  | 'facebook-pixel'
  | 'customer-io'
  | 'amplitude'
  | 'user-guiding';

export class Analytics {
  _storeId: string;
  _initialized: boolean = false;

  get analytics(): AnalyticsWindow {
    return window.t3m;
  }

  initializeGTM = () => {
    this.analytics('init', 'google-tag-manager', environment.gaMeasurementId, {
      mapTrackEvent: (name, params) => {
        const eventName = name.replaceAll(' ', '_').toLowerCase();

        return {
          eventName,
          params,
        };
      },
    });
  };

  initializeFacebookPixel(userId: string) {
    this.analytics(
      'init',
      'facebook-pixel',
      environment.facebookPixelId,
      {},
      {
        external_id: userId,
      }
    );
  }

  initializeCustomerIo() {
    this.analytics('init', 'customer-io', environment.customerIoKey);
  }

  initializeAmplitude(userId: string) {
    this.analytics('init', 'amplitude', environment.amplitudeKey, {}, userId);
  }
  initializeUserGuiding() {
    this.analytics('init', 'user-guiding', environment.userGuidingKey);
  }
  /* INITIALIZE EVERYTHING */
  initializeEventTracking = (storeId: string, userId: string) => {
    // if not window defined, then exit
    if (!window || !document || !document.body) return;
    if (this._initialized) return;
    this._initialized = true;
    this._storeId = storeId;

    loadScript(environment.t3mUrl, {
      async: true,
    });

    this.initializeUserGuiding();
    this.initializeGTM();
    this.initializeFacebookPixel(userId);
    this.initializeCustomerIo();
    this.initializeAmplitude(userId);

    console.log('Analytics initialized');
  };

  pageView = (category?: string, properties?: {[key: string]: string}) => {
    const p = {
      title: `${document.title}`,
      url: `${document.location.href}`,
      path: `${document.location.pathname}`,
      referrer: `${document.referrer}`,
      search: `${document.location.search}`,
    };
    this.analytics('page', category, p);
  };

  fireCustomEvent(
    eventName: string,
    properties: {[key: string]: any} = {},
    providers: Provider[] = [],
    callback?: () => void
  ) {
    const context = {
      app: {
        name: 'qempo-shop-backoffice-webapp',
        version: environment.version,
      },
    };
    const landingUTM = getCookie('tl_u');
    let parsedLandingUTM = {};
    if (landingUTM) {
      try {
        parsedLandingUTM = JSON.parse(atob(landingUTM));
      } catch (e) {
        parsedLandingUTM = {};
      }
    }

    const richProperties = {
      ...parsedLandingUTM,
      ...properties,
      store_domain: document.location.host,
      store_id: this._storeId,
      ...context,
    };
    this.analytics('track', eventName, richProperties, providers, callback);
  }

  identify(id: string, params: {[key: string]: any}) {
    this.analytics('identify', id, params);
  }
}

export default new Analytics();
